import { Photo } from "@/components/Photo";
import { SectionTitle } from "@/components/SectionHeader";
import { Eyebrow } from "@/components/Eyebrow";
import { cn } from "@/lib/cn";
import fairmontMark from "@/assets/fairmont-mark.webp";
import testimonialRoom from "@/assets/testimonial-room.webp";

export function TestimonialSection() {
  return (
    <section className="px-2 sm:px-4 py-20 md:px-6 md:py-16">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 lg:grid lg:grid-cols-2 lg:items-center lg:gap-16">
        <div className="relative w-full lg:max-w-md">
          <Photo
            src={testimonialRoom}
            alt="Guest room with warm lighting and a Somo keypad by the bed"
            className="h-96 w-full rounded-card md:h-120 lg:aspect-[443/531] lg:h-auto"
          />
          <div className="absolute bottom-0 right-0 rounded-tl-2xl bg-primary pl-2 pt-2 lg:hidden">
            <FairmontMark />
          </div>
        </div>
        <div className="contents md:flex md:flex-1 md:flex-col md:gap-12 lg:gap-32">
          <div className="flex flex-col gap-32 px-6 sm:px-4 md:px-0">
            <FairmontMark className="hidden lg:block" />
            <div className="flex flex-col gap-6">
              <Eyebrow>Property Stories • Fairmont hotel &amp; resorts</Eyebrow>
              <SectionTitle size="small">
                Meet brand standards without rebuilding the room
              </SectionTitle>
              <p className="text-sm leading-normal tracking-body text-secondary md:text-base md:leading-relaxed">
                Somo upgraded guest room controls across the property without
                touching the walls, so the rooms met brand standard on the
                original renovation schedule.
              </p>
            </div>
          </div>
          <div
            aria-hidden
            className="order-3 flex items-center justify-between md:order-none"
          >
            <div className="flex items-center gap-3 md:gap-2">
              <span className="size-2 rounded-full bg-accent md:w-6 md:bg-indicator-active" />
              <span className="size-2 rounded-full bg-indicator" />
              <span className="size-2 rounded-full bg-indicator" />
            </div>
            <div className="flex gap-2 text-secondary lg:hidden">
              <Chevron />
              <Chevron className="rotate-180" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FairmontMark({ className }: { className?: string }) {
  return (
    <img
      loading="lazy"
      decoding="async"
      src={fairmontMark}
      alt="Fairmont Hotels & Resorts"
      className={cn("h-16 w-auto object-contain object-left", className)}
    />
  );
}

function Chevron({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("size-5", className)}
    >
      <path d="M12.5 4 6.5 10l6 6" />
    </svg>
  );
}
